import { forwardRef } from "react";
import { Button, ButtonProps, Tooltip } from "@jhool-io/fe-components";
import { cn } from "../../utils/helpers";

export interface ActionButtonProps extends ButtonProps {
    /** button content */
    children: React.ReactNode;
    /** tooltip title */
    actionTitle: string;
    className?: string;
}

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
    function ActionButton({ children, className, actionTitle, ...props }, ref) {
        return (
            <Tooltip content={actionTitle}>
                <Button ref={ref} {...props} className={cn(className)}>
                    {children}
                </Button>
            </Tooltip>
        );
    }
);

export default ActionButton;
